import { evaluate } from "mathjs";
export default class Condition {
    constructor({ formula, yes, no }) {
        this.type = "condition";
        this.formula = formula;
        this.yes = yes !== null && yes !== void 0 ? yes : true;
        this.no = no !== null && no !== void 0 ? no : false;
    }
    evaluate(params) {
        return evaluate(this.formula, params) ? this.yes : this.no;
    }
    toJSON() {
        return {
            "type": "condition",
            "formula": this.formula,
        };
    }
    static eval(expression, params) {
        if (expression instanceof Condition) {
            return expression.evaluate(params);
        }
        return expression;
    }
}
